import type { FlagGroup } from '@/models/template';

export const TECHNICALLY_DIFFICULT_FLAG = 'TECHNICALLY_DIFFICULT';

const FLAG_VARIANTS: Record<string, 'success' | 'warning'> = {
  SIGNIFICANT_FINDINGS: 'success',
  [TECHNICALLY_DIFFICULT_FLAG]: 'warning',
};

export const getFlagVariant = (
  flagClass: string
): 'success' | 'warning' | 'default' => FLAG_VARIANTS[flagClass] ?? 'default';

export function isTechnicallyDifficultFlag(flagClass: string): boolean {
  return flagClass === TECHNICALLY_DIFFICULT_FLAG;
}

export function computeFlagRestrictions(
  flagGroups: FlagGroup[],
  userRole: string
): { disabledFlags: Set<string>; disabledFlagHints: Map<string, string> } {
  const disabledFlags = new Set<string>();
  const disabledFlagHints = new Map<string, string>();
  const normalizedRole = userRole.toLowerCase();

  flagGroups.forEach((group) => {
    group.flagLabels.forEach((label) => {
      const { allowedRoles } = label;
      if (!allowedRoles || allowedRoles.length === 0) return;

      const isAllowed = allowedRoles.some(
        (role) => role.toLowerCase() === normalizedRole
      );
      if (!isAllowed) {
        disabledFlags.add(label.flagClass);
        const roleNames = allowedRoles
          .map((r) => r.charAt(0).toUpperCase() + r.slice(1).toLowerCase())
          .join(', ');
        disabledFlagHints.set(
          label.flagClass,
          `Only ${roleNames} can modify this flag`
        );
      }
    });
  });

  return { disabledFlags, disabledFlagHints };
}
